(() => {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initReveal(root = document) {
    const items = [...root.querySelectorAll('[data-ela-reveal]')];
    if (!items.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });

    items.forEach((item) => observer.observe(item));
  }

  function initGallery(root = document) {
    const mainImage = root.querySelector('[data-ela-main-image]');
    const thumbs = [...root.querySelectorAll('[data-ela-thumb]')];
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const nextSrc = thumb.dataset.src;
        const nextAlt = thumb.dataset.alt || '';
        if (!nextSrc || mainImage.src === nextSrc) return;

        mainImage.style.opacity = '.25';
        window.setTimeout(() => {
          mainImage.src = nextSrc;
          mainImage.alt = nextAlt;
          mainImage.style.opacity = '1';
        }, 130);

        thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  function initMobileBuy(root = document) {
    const mobileButton = root.querySelector('[data-ela-mobile-buy]');
    const primaryButton = root.querySelector('[data-ela-primary-buy]');
    const mobileBar = root.querySelector('.ela-mobile-buy');
    if (!mobileButton || !primaryButton || !mobileBar) return;
    mobileButton.addEventListener('click', () => primaryButton.click());

    const update = () => {
      mobileBar.classList.toggle('is-visible', primaryButton.getBoundingClientRect().bottom < 0);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function initHeader() {
    const update = () => document.body.classList.toggle('ela-header-scrolled', window.scrollY > 20);
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function init(root = document) {
    if (!root.querySelector('.ela-page')) return;
    document.documentElement.classList.add('ela-js');
    initReveal(root);
    initGallery(root);
    initMobileBuy(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      initHeader();
    }, { once: true });
  } else {
    init();
    initHeader();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();



(() => {
  const enhanceProductPage = (root) => {
    if (!root || root.dataset.elaCroEnhanced === 'true') return;
    root.dataset.elaCroEnhanced = 'true';

    const intro = root.querySelector('.ela-product-nav')?.nextElementSibling;
    const testimonials = root.querySelector('#ela-temoignages');
    const leadCapture = root.querySelector('#ela-checklist-gratuite');

    if (intro && testimonials) intro.insertAdjacentElement('afterend', testimonials);
    if (testimonials && leadCapture) testimonials.insertAdjacentElement('afterend', leadCapture);

    const purchaseBox = root.querySelector('.ela-purchase-box');
    if (purchaseBox && !root.querySelector('.ela-hero-proof')) {
      const proof = document.createElement('aside');
      proof.className = 'ela-hero-proof';
      proof.setAttribute('aria-label', 'Résultats de clients accompagnés');
      proof.innerHTML = '<p class="ela-hero-proof__title">Plus de 40 entrepreneurs accompagnés dans leur lancement</p><div class="ela-hero-proof__items"><span class="ela-hero-proof__item"><strong>Mehdi B.</strong>Activité lancée et 3 véhicules après 6 mois</span><span class="ela-hero-proof__item"><strong>Thomas L.</strong>5 véhicules et activité principale après 1 an</span></div>';
      purchaseBox.insertAdjacentElement('afterend', proof);
    }

    const primaryButton = root.querySelector('[data-ela-primary-buy]');
    const mobileBar = root.querySelector('.ela-mobile-buy');
    const syncMobileBar = () => {
      if (!primaryButton || !mobileBar) return;
      const rect = primaryButton.getBoundingClientRect();
      const primaryIsVisible = rect.top < window.innerHeight && rect.bottom > 0;
      mobileBar.classList.toggle('is-visible', window.scrollY > 80 && !primaryIsVisible);
    };

    syncMobileBar();
    window.addEventListener('scroll', syncMobileBar, { passive: true });
    window.addEventListener('resize', syncMobileBar, { passive: true });

    const publish = (eventName, detail) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...detail });
      document.dispatchEvent(new CustomEvent(`ela:${eventName}`, { detail }));
    };

    root.querySelectorAll('[data-ela-primary-buy], [data-ela-mobile-buy], .ela-final-purchase button').forEach((button) => {
      button.addEventListener('click', (event) => {
        if (!event.isTrusted) return;
        const placement = button.hasAttribute('data-ela-mobile-buy')
          ? 'sticky_mobile'
          : button.closest('.ela-final-purchase')
            ? 'final'
            : 'hero';
        publish('cta_click', { placement, product: document.title });
      });
    });

    const leadForm = leadCapture?.querySelector('form');
    leadForm?.addEventListener('submit', (event) => {
      if (event.isTrusted) publish('lead_submit', { placement: 'checklist' });
    });
  };

  const run = () => document.querySelectorAll('.ela-product-page').forEach(enhanceProductPage);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
